// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2J_s_","label":"Section_label__EfZTQ","contentWrap":"Section_contentWrap__30p9N","footer":"Section_footer__1mImU","footerInner":"Section_footerInner__3M_YD"};